<template>
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="4">
          <v-card class="pa-2">
            <v-card-title>
              <h4>Détail de la fiche</h4>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <b>Libelle / Version: </b>
              {{ this.$store.getters["Auth/get_selected_ficheexc"].libelle }}
              <v-spacer class="my-1"></v-spacer>
              <b>Nom du fichier: </b>
              {{ this.$store.getters["Auth/get_selected_ficheexc"].fileName }}
              <v-spacer class="my-1"></v-spacer>
            </v-card-text>
          </v-card>

        </v-col>
        <v-col cols="12" md="8">
          <v-card>
            <v-card-title>
              <h4>Aperçu de la fiche</h4>
              <v-spacer></v-spacer>
              <v-btn small @click="downloadFiche()" class="primary">
                <v-icon>mdi-download</v-icon>
                Télécharger
              </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="height:62em !important;overflow:hidden">
              <VueDocPreview
                style="height:100%"
                v-if="
                  this.$store.getters['Auth/get_selected_ficheexc'].fileType == 'doc' ||
                    this.$store.getters['Auth/get_selected_ficheexc'].fileType == 'docx' ||
                    this.$store.getters['Auth/get_selected_ficheexc'].fileType == 'xls' ||
                    this.$store.getters['Auth/get_selected_ficheexc'].fileType == 'xlsx' ||
                    this.$store.getters['Auth/get_selected_ficheexc'].fileType == 'XLS' ||
                    this.$store.getters['Auth/get_selected_ficheexc'].fileType == 'XLSX'
                "
                :value="this.$store.getters['Auth/get_selected_ficheexc'].fileLink"
                type="office"
              />
  
              <vue-friendly-iframe
                v-if="this.$store.getters['Auth/get_selected_ficheexc'].fileType == 'pdf'"
                :src="
                  this.$store.getters['Auth/get_selected_ficheexc'].fileLink + '#toolbar=0'
                "
                frameborder="0"
                loading="lazy"
              ></vue-friendly-iframe>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  import VueDocPreview from "vue-doc-preview";
  
  export default {
    components: {
      VueDocPreview
    },
    props: {
      id: {
        type: Number,
        required: true
      }
    },
    data: () => ({
      profile: 0,
      dialog: false,
      ppmRev: {
        file: [],
        description: ""
      },
      ppm: [],
      items: [
        {
          text: "Tableau de bord",
          disabled: false,
          href: "/dashboard"
        },
        {
          text: "Plan de passations des marchés",
          disabled: false,
          href: { name: "welcomePpm" }
        },
        {
          text: "Détail du plan de passation des marchés (PPM) publié",
          disabled: true
        }
      ]
    }),
    created() {
      this.$store.dispatch("Auth/loadFicheDemandeExcById", this.id);
      let Virt = [];
      Virt = JSON.parse(localStorage.getItem("userData"));
      this.profile = Virt.profile.status;
    },
    methods: {
      getInit() {
        this.InitLink = this.$store.getters["Auth/get_selected_ficheexc"].file_link;
        console.log("INFOS", InitLink);
      },
      downloadFiche() {
        const data = new FormData();
        data.append("id", this.id);
        this.$store.dispatch("Auth/downloadFiche", data);
      }
    }
  };
  </script>
  <style>
  .w-62em {
    height: 62em !important;
    width: 100% !important;
  }
  .v-card__text {
    width: 100% !important;
  }
  .vue-friendly-iframe iframe {
    width: 100% !important;
    height: 62em !important;
  }
  h4{
  word-break: break-word
}
  </style>
  